module.exports = "/_next/static/images/ic_beer-995eb70884946e81e146100d76a79cf3.png";